import React from 'react'

interface ISupportHeadsetIconProps {
  size?: number
  color?: string
  style?: React.CSSProperties
}

export default function SupportHeadsetIcon({ size = 16, color = 'currentColor', style }: ISupportHeadsetIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, display: 'inline-block', verticalAlign: 'middle', ...style }}
    >
      <path d="M3 11h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-5a9 9 0 0 1 18 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h1" />
      <path d="M21 18v2a2 2 0 0 1-2 2h-4" />
      <path d="M13 22h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2z" />
    </svg>
  )
}
